"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _styledReactModal = require("styled-react-modal");

var _merge = _interopRequireDefault(require("lodash/merge"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _styles = require("../../modal/styles");

var _Head = require("../../head/Head");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A helper component for wrapping ReAssure-UI React apps
 */
const AppProvider = ({
  theme,
  head,
  children
}) => {
  // merge the themes so that the defaults aren't overwritten if any values aren't defined
  const appTheme = (0, _merge.default)({}, _theme.default, theme);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styledComponents.ThemeProvider, {
    theme: appTheme,
    className: "theme-provider",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Head.Head, { ...head
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledReactModal.ModalProvider, {
      backgroundComponent: _styles.ModalBackground,
      children: children
    })]
  });
};

AppProvider.propTypes = {
  theme: _propTypes.default.object,
  head: _propTypes.default.object
};
var _default = AppProvider;
exports.default = _default;